import parse from 'html-react-parser';

export const TYPE_ACCOUNT = [
  "Quản trị viên",
  "Nhân viên"
];
export const ID_TYPE_ACCOUNT = {
  QUAN_TRI: 0,
  GIAO_VIEN: 1,
  HOC_SINH: 2,
  PHU_HUYNH: 3,
}
export const LIST_TABLE = [
  "schools",
  "grades",
  "class",
  "students",
  "subjects",
  "timetable",
  "users",
  "years",
];
export const LIST_ALPHA = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
export const LIST_NATION = [
  "Kinh",
  "Tày",
  "Thái",
  "Mường ",
  "Khmer",
  "Hoa ",
  "Nùng  ",
  "Mông",
  "Dao",
  "Gia Rai",
  "Ê  Đê",
  "Ba Na",
  "Sán Chay ",
  "Chăm ",
  "Cơ Ho",
  "Xơ Đăng",
  "Sán Dìu",
  "Hrê",
  "RaGlay",
  "Mnông",
  "Thổ",
  "Xtiêng",
  "Khơ mú",
  "Bru Vân Kiều",
  "Cơ Tu",
  "Giáy",
  "Tà Ôi",
  "Mạ",
  "Giẻ-Triêng",
  "Co",
  "Chơ Ro",
  "Xinh Mun",
  "Hà Nhì",
  "Chu Ru",
  "Lào",
  "La Chí",
  "Kháng",
  "Phù Lá",
  "La Hủ",
  "La Ha",
  "Pà Thẻn",
  "Lự",
  "Ngái",
  "Chứt",
  "Lô Lô",
  "Mảng",
  "Cơ Lao",
  "Bố Y",
  "Cống",
  "Si La",
  "Pu Péo",
  "Rơ Măm",
  "Brâu",
  "Ơ Đu",
];
export const COLORS_CHECK = [
  "#999",
  "#21c83d",
  "#efd732",
  "#fd7a23",
  "#db0d18",
];

export const RolesRight = {

  dashboard: { title: "Cộng đồng Blue", checked: false },
  "tra-cuu-lich-su": { title: "Tra cứu lịch sử thay đổi nhân viên", checked: false },
  "cay-nhan-su": { title: "Cây nhân sự", checked: false },
  "dat-xe": {
    title: "Đặt Xe",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false }
    },
  },
  "dat-phong-hop": {
    title: "Đặt phòng họp",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false }
    },
  },
  "dat-cho-ngoi": {
    title: "Đặt chỗ ngồi",
    checked: false,
    children: {
      add: { title: "Đặt chỗ", checked: false }
    },
  },
  "quan-tri-cho-ngoi": {
    title: "Quản trị đặt chỗ ngồi",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      cancel: { title: "Huỷ booking", checked: false },
    },
  },
  "list-users_onday": {
    title: "Bảng chấm công chi tiết",
    checked: false,
    children: {
      upload: { title: "Upload", checked: false },
      view: { title: "Xem", checked: false },
      edit: { title: "Sửa", checked: false },
      viewallpart: { title: "Xem theo phòng ban", checked: false },
      viewallcompany: { title: "Xem theo công ty", checked: false },
      viewall: { title: "Xem tất cả", checked: false },

    },
  },
  "list-cham-cong-thang": {
    title: "Bảng chấm công tháng",
    checked: false,
    children: {
      view: { title: "Xem", checked: false },
      viewallpart: { title: "Xem theo phòng ban", checked: false },
      viewallcompany: { title: "Xem theo công ty", checked: false },
      viewall: { title: "Xem tất cả", checked: false },
      export: { title: "Xuất bảng chấm công", checked: false },
      chotcong: { title: "Chốt bảng chấm công", checked: false },
    },
  },
  "list-users-break": {
    title: "Đăng ký xin nghỉ/đi muộn/về sớm",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      viewallpart: { title: "Xem theo phòng ban", checked: false },
      viewallcompany: { title: "Xem theo công ty", checked: false },
      viewall: { title: "Xem tất cả", checked: false },
      export: { title: "Xuất", checked: false },
      editcheck: { title: "Sửa người duyệt", checked: false },
    },
  },

  "list-approve-break": {
    title: "Phê duyệt xin nghỉ/đi muộn/về sớm",
    checked: false,
    children: {
      viewallpart: { title: "Xem theo phòng ban", checked: false },
      viewallcompany: { title: "Xem theo công ty", checked: false },
      approve: { title: "Phê duyệt", checked: false },
    },
  },
  "list-giaitrinh": {
    title: "Giải trình công",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      editcheck: { title: "Sửa người duyệt", checked: false },
      delete: { title: "Xoá", checked: false },
      reopen: { title: "Mở lại", checked: false },
      export: { title: "Xuất", checked: false },
      viewallpart: { title: "Xem theo phòng ban", checked: false },
      viewallcompany: { title: "Xem theo công ty", checked: false },
      viewall: { title: "Xem tất cả", checked: false },
    },
  },
  "list-duyet-giai-trinh": {
    title: "Phê duyệt giải trình công",
    checked: false,
    children: {
      approve: { title: "Phê duyệt", checked: false },
    },
  },

  "list-users": {
    title: "Quản lý tài khoản",
    table: "users",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      upload: { title: "Upload", checked: false },
      export: { title: "Xuất dữ liệu", checked: false },
      parts: { title: "Bộ phận", checked: false },
      roles: { title: "Phân quyền", checked: false },
      login: { title: "Đăng nhập", checked: false },
      leave: { title: "Ngày phép", checked: false },
      viewallpart: { title: "Quản lý theo phòng ban", checked: false },
      viewallcompany: { title: "Quản lý theo công ty", checked: false },
      viewall: { title: "Quản lý tất cả", checked: false },
      view_manager: { title: "Quản lý theo nhiều phòng ban", checked: false },
      resetphep: { title: "Reset phép năm", checked: false },
    },
  },

  "update-nhan-su": {
    title: "Cập nhật nhân sự",
    checked: false,
  },
  "users_login": {
    title: "Theo dõi đăng nhập",
    checked: false,
  },
  "list-roles": {
    title: "Quản lý quyền hạn",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },

  "list-parts": {
    title: "Quản lý phòng ban",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      // member: { title: "Nhân sự", checked: false },
      viewallcompany: { title: "Xem theo công ty", checked: false },
      viewall: { title: "Xem tất cả", checked: false },
    },
  },
  "list-chucvu": {
    title: "Danh sách chức vụ",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      viewallcompany: { title: "Xem theo công ty", checked: false },
      viewall: { title: "Xem tất cả", checked: false },
    },
  },
  "list-company": {
    title: "Quản lý công ty thành viên",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },


  "list-settings": {
    title: "Quản lý cài đặt thông số",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "list-users_onday_settings": {
    title: "Cài đặt giờ chấm công",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "cai-dat-nhan-su": {
    title: "Cài đặt nhân sự",
    checked: false,
  },
  "cai-dat-ngay-chot-cong": {
    title: "Cài đặt ngày chốt công",
    checked: false,
    children: {
      edit: { title: "Sửa", checked: false },
    },
  },
  "cai-dat-cong": {
    title: "Cài đặt công",
    checked: false,
    children: {
      edit: { title: "Sửa", checked: false },
    },
  },
  "ngay-le": {
    title: "Ngày lễ trong năm",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "che-do": {
    title: "Nghỉ chế độ",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "lambu": {
    title: "Quản lý ngày làm bù",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },

  "list-ca-lam": {
    title: "Ca làm việc",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "quan-ly-ca": {
    title: "Quản lý ca làm việc",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "phan-ca-lam": {
    title: "Phân ca làm việc",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "danh-sach-gui-mail": {
    title: "Hệ thống gửi mail",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },

    },
  },
  "test-email": {
    title: "Test mail",
    checked: false,
  },
  "users-customizer": {
    title: "Tùy biến form nhân sự",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },

  "danh-muc-tin": {
    title: "Quản lý danh mục quy trình nội bộ",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      viewallcompany: { title: "Xem theo công ty", checked: false },
      viewall: { title: "Xem tất cả", checked: false },
    },
  },
  "mau-hop-dong": {
    title: "Quản lý mẫu hợp đồng",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "hop-dong": {
    title: "Quản lý hợp đồng",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      upload: { title: "Import", checked: false },
    },
  },
  "van-thu": {
    title: "Quản lý Văn thư lưu trữ",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      export: { title: "Xuất dữ liệu", checked: false },
      changemodal: { title: "Đổi người cấp số/xin số", checked: false },
    },
  },
  "vanthu_param": {
    title: "Phân loại Văn thư lưu trữ",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "phan-cong-cap-so": {
    title: "Phân công cấp số",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "danh-sach-tin": {
    title: "Quản lý danh sách quy trình nội bộ",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      viewallcompany: { title: "Xem theo công ty", checked: false },
      viewall: { title: "Xem tất cả", checked: false },
    },
  },
  "users_new": {
    title: "Quản lý ứng viên",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      export: { title: "Xuất", checked: false },
      delete: { title: "Xoá", checked: false },
      viewall: { title: "Xem tất cả", checked: false },
      viewdepartment: { title: "Xem theo phòng ban", checked: false },
      viewcompany: { title: "Xem theo công ty", checked: false },
      view_manager: { title: "Xem theo Phòng ban NS quản lý", checked: false },
    },
  },
  "users_ctv": {
    title: "Quản lý CTV sale",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      export: { title: "Xuất", checked: false },
      delete: { title: "Xoá", checked: false },
      viewall: { title: "Xem tất cả", checked: false },
      viewdepartment: { title: "Xem theo phòng ban", checked: false },
    }
  },
  "link-ung-vien": {
    title: "Link ứng viên",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "users_gitiho": {
    title: "Quản lý tài khoản Gitiho",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "quan-ly-qrcode": {
    title: "Quản lý QRcode",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "quan-ly-xe": {
    title: "Quản lý Xe",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },

  "quan-ly-phong-hop": {
    title: "Quản lý phòng họp",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "may-cham-cong": {
    title: "Quản lý máy chấm công",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "quan-ly-sticker": {
    title: "Quản lý Sticker",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "bangchotcongthang": {
    title: "Bảng chốt công tháng",
    checked: false,
  },
  "logs": {
    title: "Lịch sử người dùng",
    checked: false,
  },
  "posts": {
    title: "Đăng bài lên Cộng đồng Blue",
    checked: false,
  },
  "post_group": {
    title: "Quản lý danh mục cộng đồng",
    checked: false,
  },
  "deletecomment": {
    title: "Xóa comment Cộng đồng Blue",
    checked: false,
  },
  "pinpost": {
    title: "Pin bài viết Cộng đồng Blue",
    checked: false,
  },
  "deletepost": {
    title: "Xóa bài viết Cộng đồng Blue",
    checked: false,
  },
  "bao-cao-xe-phong-hop": {
    title: "Báo cáo dịch vụ hành chính",
    checked: false,
  },
  "bao-cao-nhan-su": {
    title: "Báo cáo nhân sự",
    checked: false,
  },
  "calendar": {
    title: "Quản lý sự kiện",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "checkin": {
    title: "Quản lý Checkin",
    checked: false,
    children: {
      follow: { title: "Theo dõi checkin", checked: false },
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "capbac": {
    title: "Quản lý cấp bậc",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "blue-form": {
    title: "Quản lý Blue Form",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "blue-counting": {
    title: "Thống kê Blue",
    checked: false,
    children: {
      view: { title: "Xem", checked: false },
    },
  },
  "tan-tuyen": {
    title: "Tân tuyển",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "workflow_type": {
    title: "Phân loại tờ trình",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      viewall: { title: "Xem tất cả", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "workflow_walking": {
    title: "Quản lý tờ trình",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      viewall: { title: "Xem tất cả", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      cancle: { title: "Hủy bỏ", checked: false },
      fastcheck: { title: "Duyệt nhanh", checked: false },
      statistic: { title: "Báo cáo cá nhân", checked: false },
      statistic_group: { title: "Báo cáo nhóm", checked: false },
    },
  },
  "learning_profile_manager": {
    title: "Quản lý Profile",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "learninghub-profile": {
    title: "Danh sách Profile",
    checked: false,
    children: {
      view: { title: "Xem", checked: false },
    },
  },
  "learninghub_baigiang": {
    title: "Quản lý bài giảng",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "khoa-hoc": {
    title: "Khóa học",
    checked: false,
    children: {
      view: { title: "Xem", checked: false },
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "learninghub_cauhoi": {
    title: "Ngân hàng câu hỏi",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "learninghub_dethi": {
    title: "Bài kiểm tra / Bài tập",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "learninghub_bailam": {
    title: "Chấm bài / Bài làm thí sinh",
    checked: false,
    children: {
      view: { title: "Xem", checked: false },
      cham: { title: "Chấm bài", checked: false }
    },
  },
  "purchasing_supplier": {
    title: "Mua sắm - Nhà cung cấp",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "purchasing_walking": {
    title: "Dịch vụ mua sắm",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "works_mission": {
    title: "Nghiệp vụ cá nhân",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      deparment: { title: "QL Theo phòng ban", checked: false },
      all: { title: "Quản lý tất cả", checked: false },
    },
  },
  "works_order": {
    title: "Quản lý công việc",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      assign: { title: "Giao việc", checked: false },
      deparment: { title: "QL Theo phòng ban", checked: false },
      all: { title: "Quản lý tất cả", checked: false },
    },
  },
  "users_leave": {
    title: "Nhân sự nghỉ nhiều",
    checked: false,
    children: {

    },
  },
};


export const CONFIG_EDITOR = {

  toolbar: {
    items: [
      'heading', 'MathType', 'ChemType',
      '|',
      'bold',
      'italic',
      'link',
      'bulletedList',
      'numberedList',
      'imageUpload',
      'mediaEmbed',
      'insertTable',
      'blockQuote',
      'undo',
      'redo'
    ]
  },
}
export const CONFIG_STEP_TEST_1 = ['Thông tin phiếu bài', 'Lựa chọn câu hỏi', 'Chọn học sinh']
export const CONFIG_STEP_TEST_2 = ['Thông tin đề kiểm tra', 'Lựa chọn câu hỏi', 'Phát đề kiểm tra']

export const getApprovalStatus = (progress, currentUserId) => {
  if (!progress) return "pending";
  if (progress.user_id === currentUserId) {
    if (progress.master_check === 1) return "approved";
    if (progress.master_check === -1) return "rejected";
    return "pending";
  }
  if (Array.isArray(progress.list_kyphu)) {
    const kyphu = progress.list_kyphu.find(kp => kp.user_id === currentUserId);
    if (kyphu) {
      if (kyphu.check === 1) return "approved";
      if (kyphu.check === -1) return "rejected";
      return "pending";
    }
  }
  return "pending";
};

export const MyCurrentTime = () => {
  const now = new Date();

  const d = String(now.getDate()).padStart(2, '0');
  const m = String(now.getMonth() + 1).padStart(2, '0'); // Tháng trong JS chạy từ 0-11
  const y = now.getFullYear();

  const h = String(now.getHours()).padStart(2, '0');
  const i = String(now.getMinutes()).padStart(2, '0');
  const s = String(now.getSeconds()).padStart(2, '0');

  return `${y}-${m}-${d} ${h}:${i}:${s}`;
};

export const convertToSqlDate = (str) => {
  if (!str || str.includes('_')) return null;

  // Tách: ["14:30", "08-04-2026"]
  const parts = str.trim().split(' ');
  if (parts.length < 2) return null;

  const timePart = parts[0]; // "14:30"
  const datePart = parts[1]; // "08-04-2026"

  const [d, m, y] = datePart.split('-');

  // Trả về định dạng chuẩn SQL: YYYY-MM-DD HH:mm:00
  return `${y}-${m}-${d} ${timePart}:00`;
};

export const vnDateTime = (dateInput) => {
  if (!dateInput || typeof dateInput !== 'string' || dateInput.length < 10) return "";

  // Giả sử API trả về: "2026-04-08 10:30:00" hoặc "2026-04-08T10:30:00"
  try {
    const parts = dateInput.replace('T', ' ').split(' '); // Tách Ngày và Giờ
    const datePart = parts[0]; // "2026-04-08"
    const timePart = parts[1] || "00:00:00"; // "10:30:00"

    const [y, m, d] = datePart.split('-');
    const [h, i] = timePart.split(':');

    // Trả về đúng định dạng Mask: HH:mm DD-MM-YYYY
    return `${h}:${i} ${d}/${m}/${y}`;
  } catch (e) {
    console.error("Lỗi parse date:", e);
    return "";
  }
};

export const linkify = (text) => {
  if (!text) return text;

  // Regex để tìm URL (bắt đầu bằng http, https)
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  // Tách text thành mảng các đoạn text và các link
  return text.split(urlRegex).map((part, index) => {
    // Nếu đoạn part khớp với regex (là link)
    if (part.match(urlRegex)) {
      return (
        <a 
          key={index} 
          href={part} 
          target="_blank" 
          style={{maxWidth:"100%",overflow:"hidden"}}
          rel="noopener noreferrer"
          className="d-inline-block text-danger" // Style tùy chọn
        >
          <strong>{part}</strong>
        </a>
      );
    }
    // Nếu là text bình thường
    return parse(part);
  });
};